import React, { useContext } from 'react';
import {
  viewContract,
  downloadContract,
  getContract,
  viewSavedContract,
  downloadSavedContract,
} from '../confirm-document/order-summary';
import { OnboardingSummaryContext } from 'src/context/onboarding-summary-context';
import { SalesforceContext } from 'src/context/salesforce-context';
import { Print as PrintIcon, Download as DowmloadIcon } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';
import './document-view-download-buttons.scss';

const PDFKEY = 'contract-pdf';

export async function SaveDocument(
  merchant,
  lead,
  getDeliveriesToDisplay,
  getDeviceOrderQuantity,
  uniqueTerminals,
  deviceQuantitiesToDisplay,
  totalPrice,
  onceOffCost,
  customerType,
) {
  const storePdf = (data) => {
    localStorage.setItem(PDFKEY, data);
  };

  await getContract(
    merchant,
    lead,
    getDeliveriesToDisplay(),
    getDeviceOrderQuantity,
    uniqueTerminals,
    deviceQuantitiesToDisplay(),
    totalPrice,
    onceOffCost,
    customerType,
    storePdf,
  );
}

export function SavedDocumentViewButtons(customerType) {
  const base64Contract = localStorage.getItem(PDFKEY);
  return base64Contract ? (
    <div className="DocumentViewDownloadButtons button-bar-amount-total-footer">
      <p
        className="button remove-link is-clickable print-or-download"
        onClick={() => {
          TealiumEvents.thankYouClickPrint(customerType);
          viewSavedContract(base64Contract);
        }}
        automationid="Onboarding_Create_Account_Confirm_Paragraph_View_Contract_PDF"
      >
        <img src={PrintIcon} />
      </p>

      <p
        className="button remove-link is-clickable print-or-download"
        style={{ border: 'none' }}
        onClick={() => {
          TealiumEvents.thankYouClickDownload(customerType);
          downloadSavedContract(base64Contract);
        }}
        automationid="Onboarding_Create_Account_Confirm_Paragraph_Download_Contract_PDF"
      >
        <img src={DowmloadIcon} />
      </p>
    </div>
  ) : (
    <span />
  );
}

export default function DocumentViewDownloadButtons() {
  const { lead, merchant, uniqueTerminals, getDeviceOrderQuantity, customerType } = useContext(
    SalesforceContext,
  );

  const { deviceQuantitiesToDisplay, totalPrice, getDeliveriesToDisplay, onceOffCost } = useContext(
    OnboardingSummaryContext,
  );

  return (
    <div className="DocumentViewDownloadButtons button-bar-amount-total-footer">
      <p
        className="button remove-link is-clickable print-or-download"
        onClick={() => {
          TealiumEvents.confirmClickPrint(customerType);
          viewContract(
            merchant,
            lead,
            getDeliveriesToDisplay(),
            getDeviceOrderQuantity,
            uniqueTerminals,
            deviceQuantitiesToDisplay(),
            totalPrice,
            onceOffCost,
            customerType,
            lead,
          );
        }}
        automationid="Onboarding_Create_Account_Confirm_Paragraph_View_Contract_PDF"
      >
        <img src={PrintIcon} />
      </p>

      <p
        className="button remove-link is-clickable print-or-download"
        style={{ border: 'none' }}
        onClick={() => {
          TealiumEvents.confirmClickDownload(customerType);
          downloadContract(
            merchant,
            lead,
            getDeliveriesToDisplay(),
            getDeviceOrderQuantity,
            uniqueTerminals,
            deviceQuantitiesToDisplay(),
            totalPrice,
            onceOffCost,
            customerType,
            lead,
          );
        }}
        automationid="Onboarding_Create_Account_Confirm_Paragraph_Download_Contract_PDF"
      >
        <img src={DowmloadIcon} />
      </p>
    </div>
  );
}
